import { WidgetProps } from "@rjsf/utils";
import { useFormSchema } from "src/api/hooks/useFormSchema";

export const SelectWidget = (props: WidgetProps) => {
  const { value, onChange, required, options, id, uiSchema } = props;
  const enumOptions = options?.enumOptions || [];
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;
  const textColor = schema?.theme?.colors?.text;

  return (
    <div className="select-container">
      <select
        className="select-value"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value || undefined)}
        required={required}
      >
        <option value="">-- Select --</option>
        {enumOptions.map((option: any, index: number) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
